import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CModalFormDynamiqueComponent } from './c-modal-form-dynamique.component';
import { IonicModule } from '@ionic/angular';
import { CAllFieldsModule } from '../../c-all-fields/c-all-fields.module';



@NgModule({
  declarations: [CModalFormDynamiqueComponent],
  imports: [
    CommonModule,
    IonicModule,
    CAllFieldsModule
  ],
  exports: [CModalFormDynamiqueComponent],
})
export class CModalFormDynamiqueModule { }
